exports.f = {}.propertyIsEnumerable;


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/_object-pie.js
 ** module id = 31
 ** module chunks = 1
 **/